/* unplugin-vue-components disabled */import script from "./ScrollProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollProgress.vue?vue&type=script&setup=true&lang=js"

import "./ScrollProgress.vue?vue&type=style&index=0&id=3015537f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3015537f"]])

export default __exports__